import { IGetLessonWithVersionsResponse } from "api/models/response/IGetLessonWithVersionsResponse";
import { LessonVersion } from "models/LessonVersion";
import { LessonType } from "models/LessonType";
import { Image } from "components/views/editor/models/Image";
import { LessonForm } from "components/views/editor/models/LessonForm";
import { GameEditorData } from "components/views/editor/gameEditor/models/GameEditorData";
import { GameLessonVersion } from "models/LessonVersion";

export const buildLessonForm = (
    lessonData: IGetLessonWithVersionsResponse,
    version: LessonVersion,
    image: Image | null
): LessonForm => ({
    lessonName: lessonData.lessonName,
    lessonType: version.type ?? LessonType.VR,
    tagA: lessonData.tagA,
    tagB: lessonData.tagB,
    image,
    isDraft: lessonData.isDraft,
    lessonVersionName: version.name,
    description: version.description,
    maxPoints: version.maxPoints,
    shuffleAnswers: "shuffleAnswers" in version && version.shuffleAnswers === true,
    language: version.language,
    feedback: version.feedback ?? {}
});

export const buildGameEditorData = (version: GameLessonVersion): GameEditorData => ({
    fileId: version.fileId ?? null,
    launchParams: version.launchParams ?? "",
    events: (version.events ?? []).map((e) =>
        typeof e === "string"
            ? { event: e, points: 0 }
            : { event: e.eventKey ?? "", points: e.points ?? 0 }
    ),
});

export const createEmptyLessonForm = (language: string, lessonType: LessonType): LessonForm => ({
    lessonName: '',
    lessonType,
    tagA: null,
    tagB: null,
    image: null,
    isDraft: false,
    lessonVersionName: '',
    description: null,
    maxPoints: 0,
    shuffleAnswers: false,
    language,
    feedback: {}
});